import React from "react";
import { UserIcon } from "@heroicons/react/solid";
import '../customcss.css'


export default function Profile() {
  return (
      <div className="container px-5 py-10 mx-auto text-center lg:px-40">
        <UserIcon className="w-10 inline-block" />
        <h1 className="sm:text-4xl text-3xl font-medium title-font text-white">
          About me        
        </h1>
        <img src="https://pbs.twimg.com/profile_images/1589835045337866240/hgxJ4Wk4_400x400.jpg"
        className="profilephoto"/>
        <p className="container">
          I'm a self-taught developer. I started learning to code during
          COVID-19 work from home. I have practiced seriously when I started
          #100daysofcodechallenge and have recorded my progress in twitter every
          days.
        </p>
       </div>
    
  );
}
